module.exports = __webpack_public_path__ + "static/img/meeting_1.7d98a06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/meeting_1.jpg
// module id = Y1R+
// module chunks = 3